import NoAccess from './403'
import NotFound from './404'

export default function install(Vue) {
  Vue.component(NoAccess.name, NoAccess)
  Vue.component(NotFound.name, NotFound)
}
